import script from "./TicketNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketNav.vue?vue&type=script&setup=true&lang=js"

import "./TicketNav.vue?vue&type=style&index=0&id=50bd75fc&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50bd75fc"]])

export default __exports__